import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SchedulePickerProps {
  onSchedule: (publishAt: string) => void;
  onPublishNow: () => void;
  isLoading?: boolean;
  hasActiveAccounts?: boolean;
}

export function SchedulePicker({
  onSchedule,
  onPublishNow,
  isLoading,
  hasActiveAccounts = true,
}: SchedulePickerProps) {
  // Default to tomorrow at 9 AM
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(9, 0, 0, 0);
  const defaultValue = tomorrow.toISOString().slice(0, 16);

  const [scheduledAt, setScheduledAt] = useState(defaultValue);

  const handleSchedule = () => {
    if (!scheduledAt) return;
    onSchedule(new Date(scheduledAt).toISOString());
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="schedule-datetime">Schedule for</Label>
        <Input
          id="schedule-datetime"
          type="datetime-local"
          value={scheduledAt}
          min={new Date().toISOString().slice(0, 16)}
          onChange={(e) => setScheduledAt(e.target.value)}
        />
      </div>
      <div className="flex gap-2">
        <Button onClick={handleSchedule} disabled={isLoading || !scheduledAt} className="flex-1">
          Schedule Post
        </Button>
        <Button
          variant="outline"
          onClick={onPublishNow}
          disabled={isLoading || !hasActiveAccounts}
          title={!hasActiveAccounts ? 'Connect an account to publish' : undefined}
        >
          Publish Now
        </Button>
      </div>
    </div>
  );
}
